"use client";

import { useEffect } from 'react';
import { useSearchParams, usePathname } from 'next/navigation';

export function AuthCodeHandler() {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  useEffect(() => {
    // Pages that either are the callback itself or are legitimate
    // destinations for our own error redirects. Bouncing them back to
    // /auth/callback would create an infinite loop.
    const skipPaths = [
      '/auth/callback',
      '/login',
      '/forgot-password',
      '/reset-password',
    ];
    if (skipPaths.some(p => pathname === p || pathname.startsWith(p + '/'))) {
      return;
    }

    // Only redirect when we see an auth `code` on some unexpected page —
    // that's the safety net for Supabase redirecting somewhere other than
    // /auth/callback. Raw `error` params on arbitrary pages should not
    // force a detour through the callback.
    const code = searchParams.get('code');
    if (code) {
      console.log('[AuthCodeHandler] Found auth code in URL, redirecting to callback');
      const currentParams = new URLSearchParams(window.location.search);
      const callbackUrl = `/auth/callback?${currentParams.toString()}`;
      window.location.replace(callbackUrl);
    }
  }, [searchParams, pathname]);

  return null; // This component doesn't render anything
}